var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 7.3125H15.1875V17.4375H2.8125V7.3125Z",
    stroke: "#4152B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 7.3125V4.5C5.0625 3.45571 5.47734 2.45419 6.21577 1.71577C6.95419 0.977343 7.95571 0.5625 9 0.5625C10.0443 0.5625 11.0458 0.977343 11.7842 1.71577C12.5227 2.45419 12.9375 3.45571 12.9375 4.5V7.3125",
    stroke: "#4152B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockSettings);
export default __webpack_public_path__ + "static/media/block-settings.81050806.svg";
export { ForwardRef as ReactComponent };